
import axios from 'axios'
export function uploadFile(url, params) {
  return new Promise((resolve) => {
    let formData = {
      file: params.file
    }
    // var source = axios.CancelToken.source();
    axios({
      method: 'post',
      baseURL: '/payment/',
      url: url,
      timeout: 60000 * 10,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: formData
    }).then(res => {
      resolve && resolve(res);
    }).catch(() => {});
  })
}